import { render } from "./ProductSafetyInformationAccordion.vue?vue&type=template&id=670245e2"
import script from "./ProductSafetyInformationAccordion.vue?vue&type=script&lang=js"
export * from "./ProductSafetyInformationAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__